import {Breadcrumb, Spinner} from "react-bootstrap";

export default function PageContent({
    children,
    className = "",
    isLoading = false,
    isAnimated = true,
    breadcrumb = [],
    noPaddingTop = false,
    ...props
}) {

    return (
        <>
            <div className={`p-4 relative ${noPaddingTop ? 'pt-0' : ''} ${props.hasNavbarActions ? "has-navbar-actions" : ""} ${className} ${props.isLoading ? "is-loading" : ""} ${props.isAnimated ? "animate__animated animate__fadeIn" : ""}`}>
                {isLoading ? (
                    <>


                        <div class="p-4 d-flex justify-content-center">
                            <Spinner animation="border" />
                        </div>
                    </>
                ) : (
                    <>
                        {breadcrumb.length > 0 && (
                        <Breadcrumb className={"mb-0 text-muted"} listProps={{ className: "mb-0" }}>
                            {breadcrumb.map((item, index) => (
                                <Breadcrumb.Item key={index} href={item.href}>{item.label}</Breadcrumb.Item>
                            ))}
                        </Breadcrumb>
                        )}

                        <div style={{ marginTop: breadcrumb.length > 0 ? 44 : 0 }}>
                            {children}
                        </div>
                    </>
                )}
            </div>
        </>
    );

}
